import { Item, Items } from './types';

export default class DeferredRepo {
  // Constructor
  constructor(private key: string, private storage?: MinimalStorage) {}

  add(item: Item) {
    const list = this.remove(item.id);
    list.push(item);
    return this.save(list);
  }

  clear() {
    const { key, storage } = this;
    if (storage) storage.removeItem(key);
  }

  load() {
    const { key, storage } = this;
    if (!storage) return [];
    const saved = storage.getItem(key);
    try {
      const parsed: Items = JSON.parse(saved);
      return Array.isArray(parsed) ? parsed : []; 
    } catch (e) {
      // Сохранено что-то неправильное
      return [];
    }
  }

  remove(id: Item['id']) {
    const list = this.load().filter(saved => saved.id !== id);
    return this.save(list);
  }

  save(items: Items) {
    const { key, storage } = this;
    if (!storage) return [];
    storage.setItem(key, JSON.stringify(items));
    return items;
  }
}

export interface MinimalStorage {
  getItem(key: string): any;
  removeItem(key: string): any;
  setItem(key: string, data: any): any;
}


// WEBPACK FOOTER //
// ./src/store/deferred/repo.ts